import React from 'react';

const FireIcon: React.FC = () => (
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.96883 0.969727C6.07481 1.37694 8.09696 3.13497 7.33768 6.90942C7.32535 7.2314 7.53894 7.87536 8.49199 7.87536C9.6833 7.87536 9.83221 6.48225 9.79498 6.31508C10.583 7.20048 11.8314 9.62139 10.5209 12.2219C8.88289 15.4725 5.40203 15.4539 3.54061 14.3951C1.67919 13.3363 0.264555 10.7173 1.21388 8.13541C2.1632 5.55351 5.87568 3.85301 4.96883 0.969727ZM8.32464 10.4015C5.73354 11.7389 5.28432 9.27466 5.38359 7.87536C2.9079 10.2158 3.54061 11.646 3.65247 12.389C3.76433 13.132 5.55112 14.6552 7.33768 13.6707C8.76693 12.8831 8.59117 11.1631 8.32464 10.4015Z"
      fill="white"
    />
  </svg>
);

export default FireIcon;
